<div class="cell">
  <arm-form-title>Action</arm-form-title>
  <div class="cell-content">
    <ng-container *ngIf="isValueExists(item.numberPortability)">
      <div class="source">
        <div class="sub-title">Web Service:</div>
        <div class="sub-item">
                <span *ngFor="let numberPortability of item.numberPortability;let last = last;">
                    <span>&nbsp;{{numberPortability.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
        </div>
      </div>
      <div class="source" *ngIf="item.directionInfo">
        <div class="sub-title">Direction:</div>
        <div class="sub-item">{{item.directionInfo}}</div>
      </div>
      <div class="source" *ngIf="item.srcNomralizationGroup">
        <div class="sub-title">Source normalization for lookup:</div>
        <div class="sub-item">{{item.srcNomralizationGroup}}</div>
      </div>
      <div class="source" *ngIf="item.destNormalizationGroup">
        <div class="sub-title">Destination normalization for lookup:</div>
        <div class="sub-item">{{item.destNormalizationGroup}}</div>
      </div>
      <div class="source" *ngIf="item.poolId">
        <div class="sub-title">Pool:</div>
        <div class="sub-item">{{item.pool.name}}</div>
      </div>
      <div class="source" *ngIf="item.didMatch">
        <div class="sub-title">Match Incoming calls by:</div>
        <div class="sub-item">{{item.didMatch}}</div>
      </div>
      <div class="source" *ngIf="item.callExpirationTime">
        <div class="sub-title">Call Expiration Time (minutes):</div>
        <div class="sub-item">{{item.callExpirationTime}}</div>
      </div>
      <div class="source" *ngIf="item.didXHeader">
        <div class="sub-title">X-Header to add:</div>
        <div class="sub-item">{{item.didXHeader}}</div>
      </div>

    </ng-container>
    <div class="source" *ngIf="isValueExists(item.replaceWith)">
      <div class="search-by" *ngFor="let item of item.replaceWith;">
        <div class="sub-title">{{item.name | titlecase}}:</div>
        <div class="sub-item" *ngIf="item.name !== 'DISCARD CREDENTIALS'">
                    <span *ngFor="let value of item.values;let last = last;">
                        <span *ngIf="value.name">{{value.name}}<span *ngIf="!last">&bull;</span></span>
                        <span *ngIf="!value.name">{{value}}</span>
                    </span>
        </div>
      </div>
    </div>

    <div *ngIf="item.type === 'BLACK_LIST'">
      <!--
      <div class="source" *ngIf="item.poolId">
        <div class="sub-title">Pool:</div>
        <div class="sub-item">{{item.pool.name}}</div>
      </div>
      -->
      <div class="source" *ngIf="item.sourceOrDestinationNumber">
        <div class="sub-title">Source or Destination number:</div>
        <div class="sub-item">{{item.sourceOrDestinationNumber | titlecase}}</div>
      </div>
      <div class="source" *ngIf="item.callWithinNumberSeconds">
        <div class="sub-title">Call time range (sec): </div>
        <div class="sub-item">{{item.callWithinNumberSeconds}}</div>
      </div>
      <div class="source" *ngIf="item.callOccursMoreThanNumberTimes">
        <div class="sub-title">Number of calls during time range criteria: </div>
        <div class="sub-item">{{item.callOccursMoreThanNumberTimes}}</div>
      </div>
      <div class="source" *ngIf="item.blockNumberDuration">
        <div class="sub-title">Blocking number time period (min):</div>
        <div class="sub-item">{{item.blockNumberDuration}}</div>
      </div>

      <div class="source" *ngIf="isValueExists(item.whiteAttributeGroupNames)">
        <div class="sub-title">Whitelist Prefix Groups:</div>
        <div class="sub-item">
                <span *ngFor="let prefixGroup of item.whiteAttributeGroupNames; let last = last;">
                    <span title="{{prefixGroup.name}}">&nbsp;{{prefixGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
        </div>
      </div>

      <div class="source" *ngIf="isValueExists(item.whiteAttributeValues)">
        <div class="sub-title">Whitelist Prefix Attributes:</div>
        <div class="sub-item">
                <span *ngFor="let prefix of item.whiteAttributeValues; let last = last;">
                    <span title="{{prefix.value}}">&nbsp;{{prefix.value}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
        </div>
      </div>
    </div>

    <div *ngIf="item.type === 'DIDS_COUNT_MATCH'">
      <div class="source" *ngIf="item.sourceOrDestinationNumber">
        <div class="sub-title">Source or Destination number:</div>
        <div class="sub-item">{{item.sourceOrDestinationNumber | titlecase}}</div>
      </div>
      <div class="source" *ngIf="item.callOccursMoreThanNumberTimes">
        <div class="sub-title">Number of calls from first hit:</div>
        <div class="sub-item">{{item.callOccursMoreThanNumberTimes}}</div>
      </div>

      <div class="source" *ngIf="item.didCountDurationType ==='MINUTES' && item.blockNumberDuration">
        <div class="sub-title">Clear did count timer from the first hit(min):</div>
        <div class="sub-item">{{item.blockNumberDuration}}</div>
      </div>

      <div class="source" *ngIf="item.didCountDurationType ==='TIME_OF_DAY' && item.didCountTimeOfDay">
        <div class="sub-title">Clear did count at:</div>
        <div class="sub-item">{{getFormattedDidCountTimeOfDay()}} UTC</div>
      </div>
    </div>

    <div class="source" *ngIf="item.sipManipulationGroup">
      <div class="sub-title">SIP Manipulation Group:</div>
      <div class="sub-item">{{item.sipManipulationGroup.name}}</div>
    </div>

    <div class="source" *ngIf="item.alarmEnabled">
      <div class="sub-title">Generate alarm when number is blocked</div>
    </div>

    <div class="source">
      <div class="sub-title">Flow:</div>
      <div class="sub-item">{{item.flowInfo}}</div>
    </div>

    <div class="source" *ngIf="item.flow === 'CONTINUE_TO_RULE'">
      <div class="sub-title">Policy studio rule:</div>
      <div class="sub-item">{{item.continueToRule}}</div>
    </div>
  </div>
</div>
